import "bootstrap/dist/css/bootstrap.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css";

import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-toastify/dist/ReactToastify.css";

import { ConnectedRouter } from "connected-react-router";
import { PersistGate } from "redux-persist/integration/react";

import { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "shared/components/ErrorBoundary";
import { Spinner } from "shared/components/spinners/Spinner";
import App from "./App";
import "./utils/i18n";
import { store, persistor, history, base } from "./redux/store";
import { isGUID } from "./redux/helpers";

export const currentWorkspaceId = isGUID(base.split("/")[2]) ? base.split("/")[2] : null;

ReactDOM.render(
	<Provider store={store}>
		<PersistGate loading={<Spinner />} persistor={persistor}>
			<ConnectedRouter history={history}>
				<BrowserRouter basename={base}>
					<Suspense fallback={<Spinner />}>
						<ErrorBoundary>
							<App history={history} />
						</ErrorBoundary>
					</Suspense>
				</BrowserRouter>
			</ConnectedRouter>
		</PersistGate>
	</Provider>,
	document.getElementById("root")
);

